import styled from '@emotion/styled';
import RSLabel, { LabelProps as RSLabelProps } from 'reactstrap/lib/Label';

export type LabelProps = RSLabelProps;

export const Label = styled(RSLabel)`
  display: inline-block;

  margin-bottom: 8px;

  color: ${({ theme }) => theme.default.colors.n5};

  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;

export default Label;
